<template>
  <ui-modal
    id="extraCostsIntegralServices"
    ref="modal"
    size="auto"
    title="Administración Extra Costos Servicio Integral"
    @close="cerrarModal"
  >
    <!-- Menú superior -->
    <div class="d-flex flex-column" style="">
      <!-- Botones de acción -->
      <div class="d-flex" style="position: absolute; width: 50% !important">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex">
            <Button
              v-if="!loadingExtraCostsIS"
              :size="15"
              color="#2da44e"
              colorText="#ffffff"
              tooltip="Agregar extra costo"
              icon="icon fas fa-plus"
              round
              :width="30"
              class="ml-2 mb-1"
              @click.native="
                actionSetOpenAddExtraCostsISModal(true);
                is_editing = false;
              "
            />

            <!--            &lt;!&ndash; Modal &ndash;&gt;-->
            <!--            <agregar-extra-costo-modal :tipo="tipoAccion"-->
            <!--                                       :id_booking_itineraries="id_booking_itineraries"-->
            <!--                                       :data="dataSelected"-->
            <!--                                       :booking_number="booking_number" />-->

            <!--            &lt;!&ndash; Modal &ndash;&gt;-->
            <!--            <filtros-extra-costos-modal :id_booking_itineraries="id_booking_itineraries"-->
            <!--                                        :booking_number="booking_number" />-->

            <Button
              v-if="!loadingExtraCostsIS"
              :size="15"
              :width="30"
              :height="30"
              color="#0174f3"
              colorText="#ffffff"
              tooltip="Asignar tarifas a booking"
              round
              icon="fas fa-hand-holding-usd"
              class="ml-2 mb-1"
              @click.native="autoAssignExtraCosts()"
            />

            <Button
              :disabled="dataChecked.length === 0"
              :inactive="dataChecked.length === 0"
              v-if="!loadingExtraCostsIS"
              :size="15"
              :width="30"
              :height="30"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Eliminar registros seleccionados"
              round
              icon="fas fa-trash"
              class="ml-2 mb-1"
              @click.native="deleteMultiple()"
            />
          </div>

          <!--          <div class="d-flex align-items-center">-->

          <!--            <div class="d-flex align-items-center" v-if="loadingExtraCostsIS">-->

          <!--              <ui-progress-circular-->
          <!--                :stroke="3"-->
          <!--                :size="25"-->
          <!--                color="primary"-->
          <!--              />-->

          <!--              <span class="ml-2">Cargando registros</span>-->

          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>

      <!-- Datatable -->
      <Loading v-if="loadingExtraCostsIS" />

      <new-data-table
        v-if="!loadingExtraCostsIS"
        :headers="headers"
        :data="dataAux"
        :acciones="acciones"
        :seleccionar="obtenerFilaSeleccionada"
        paginacion
        withSearch
        numerador
        check
        :filaChekeada="obtenerFilaSeleccionada" />

      <!-- Totales -->
      <div v-if="!loadingExtraCostsIS" class="d-flex justify-content-end flex-wrap mt-2" style="gap: 0.75rem;">

        <div class="px-3 py-2 rounded" style="background:#eef2f7; min-width: 150px;">
          <div style="font-size: 11px; color:#6c757d; text-transform:uppercase;">Total Costos</div>
          <div style="font-size: 16px; font-weight:600; color:#0174f3;">{{ totales.totalCosto }}</div>
        </div>

        <div class="px-3 py-2 rounded" style="background:#eef2f7; min-width: 150px;">
          <div style="font-size: 11px; color:#6c757d; text-transform:uppercase;">Total Ventas</div>
          <div style="font-size: 16px; font-weight:600; color:#21831b;">{{ totales.totalVenta }}</div>
        </div>

        <div class="px-3 py-2 rounded" style="background:#eef2f7; min-width: 150px;">
          <div style="font-size: 11px; color:#6c757d; text-transform:uppercase;">Margen</div>
          <div style="font-size: 16px; font-weight:600;" :style="{ color: totales.margenNum >= 0 ? '#21831b' : '#dc3545' }">{{ totales.margen }}</div>
        </div>

      </div>

    </div>

    <add-extra-costs-modal
      :boarding_instruction_id="boarding_instruction_id"
      :service_order_id="service_order_id"
      :deposit_id="deposit_id"
      :is_boarding_instruction="is_boarding_instruction"
      :extra_cost_data="extra_cost_data"
      :is_editing="is_editing"
      :extra_cost_id="extra_cost_id"
      :booking_number="booking_number"
      @ec-modal-closed="clearECData"
      :is_documental_service="is_documental_service"
    >
    </add-extra-costs-modal>

    <!-- Modal: asignar tarifas de transporte (servicios integrales 1,2,4,5,7) -->
    <asignar-tarifas-terrestres-modal
      :show="showGroundModal"
      :booking_number="booking_number"
      :boarding_instruction_id="boarding_instruction_id"
      :plants="groundPlants"
      @close="showGroundModal = false"
      @assigned="onGroundAssigned"
    />
  </ui-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Button from "@/components/common/Button.vue";
import NewDataTable from "@/components/common/NewDataTable.vue";
import AddExtraCostsModal from "@/components/modals/serviciosLogisticos/servicioIntegral/ExtraCostIntegralServices/AddExtraCostsModal.vue";
import AsignarTarifasTerrestresModal from "@/components/modals/lineas/extraCostos/AsignarTarifasTerrestresModal.vue";
import Loading from "@/components/common/loading.vue";
import { autoAssignExtraCostIS } from "@/constants/serviciosLogisticos";
import { eliminarExtraCostos } from "@/constants/lineas";

// import Button from "../../../common/Button.vue";
// import ImportarExcelExtraCostosModal from './ImportarExcelExtraCostosModal.vue'
// import ExtraCostosTab from "@/components/modals/lineas/extraCostos/ExtraCostosTab.vue";

export default {
  props: {
    boarding_instruction_id: {
      type: Number,
      default: null,
    },
    service_order_id: {
      type: Number,
      default: null,
    },
    deposit_id: {
      type: Number,
      default: null,
    },
    is_boarding_instruction: {
      type: Boolean,
      default: false,
    },
    booking_number: {
      type: String,
      default: null,
    },

    is_documental_service: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState("serviciosLogisticos", [
      "extraCostISModalVisibility",
      "addExtraCostISModalVisibility",
      "extraCostsISData",
      "loadingExtraCostsIS"
    ]),

    // Suma de Costos (data[8]) y Ventas (data[9]); margen = ventas - costos
    totales() {

      let totalCosto = 0;
      let totalVenta = 0;

      ( this.dataAux || [] ).forEach( fila => {
        const d = ( fila && fila.data ) ? fila.data : [];
        totalCosto += parseFloat( d[8] ) || 0;
        totalVenta += parseFloat( d[9] ) || 0;
      });

      const margenNum = totalVenta - totalCosto;
      const fmt = n => n.toLocaleString( 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 } );

      return {
        totalCosto : fmt( totalCosto ),
        totalVenta : fmt( totalVenta ),
        margen     : fmt( margenNum ),
        margenNum  : margenNum,
      };
    }

  },

  // components: {  AgregarExtraCostoModal, FiltrosExtraCostosModal, NewDataTable, Button },
  components: {
    AddExtraCostsModal,
    AsignarTarifasTerrestresModal,
    NewDataTable,
    Button,
    // AgregarExtraCostoModal,
    // FiltrosExtraCostosModal,
    Loading,
  },

  data() {
    return {
      acciones: [],
      //
      is_editing: false,
      extra_cost_data: {},
      extra_cost_id: null,
      //
      dataAux: [],
      headers: [],
      id: null,
      dataChecked: [],
      showGroundModal: false,
      groundPlants: [],
    };
  },

  methods: {
    ...mapActions("serviciosLogisticos", [
      "actionSetOpenAddExtraCostsISModal",
      "actionSetOpenExtraCostsISModal",
      "actionSetExtraCostISData",
      "actionSetLoadingExtraCostsIS",
    ]),

    generarBotonesAcciones() {
      this.dataAux.map((_, index) => {
        this.acciones.push([
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },

    obtenerFilaSeleccionada(fila) {
      const { id, accion, estado } = fila;

      switch (accion) {
        case "Editar":
          this.is_editing = true;

          this.extra_cost_id = this.dataAux[id].data_complementaria.id;

          this.extra_cost_data = this.dataAux[id];

          this.actionSetOpenAddExtraCostsISModal(true);

          break;

        case "Eliminar":
          this.delete(this.dataAux[id].data_complementaria.id);

          break;
      }

      if (estado) {
        let toAdd = this.dataAux[id].data_complementaria.id;

        this.dataChecked.push(toAdd);
      } else {
        let toDelete = this.dataAux[id].data_complementaria.id;

        this.dataChecked = this.dataChecked.filter((id) => id !== toDelete);
      }
    },

    async autoAssignExtraCosts() {
      let data = {
        boarding_instruction_id: this.boarding_instruction_id ?? null,
        service_order_id: this.service_order_id ?? null,
        is_boarding_instruction: this.is_boarding_instruction,
      };

      this.$vToastify
        .prompt({
          body: "¿Desea asignar los extra costos automáticamente?",
          answers: {
            Sí: true,
            No: false,
          },
          type: "success",
        })
        .then(async (value) => {
          if (value) {
            this.$vToastify.loader("Espere por favor...");

            const { status, message, requires_ground, client_packings } = await autoAssignExtraCostIS(data);

            if (status === 200) {
              await this.getData();

              this.$vToastify.stopLoader();

              this.$vToastify.success(message, "Éxito");

              // Servicios integrales 1,2,4,5,7: abrir modal para seleccionar planta
              // y agregar las tarifas de transporte del cliente.
              if (requires_ground && Array.isArray(client_packings) && client_packings.length > 0) {
                this.groundPlants = client_packings;
                this.showGroundModal = true;
              }
            } else {
              this.$vToastify.stopLoader();

              this.$vToastify.error(message, "Error");
            }
          }
        });
    },

    async onGroundAssigned() {
      this.showGroundModal = false;
      await this.getData();
    },

    clearECData() {
      this.is_editing = false;

      this.extra_cost_data = {};

      this.extra_cost_id = null;
    },

    async getData() {
      let data = this.is_boarding_instruction
        ? { boarding_instruction_id: this.boarding_instruction_id }
        : {
            service_order_id: this.service_order_id,
            boarding_instruction_id: this.boarding_instruction_id,
          };

      await this.actionSetExtraCostISData(data);
    },

    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },

    cerrarModal() {
      this.actionSetOpenExtraCostsISModal(false);

      this.actionSetLoadingExtraCostsIS(false);
    },

    async delete(id) {
      this.$vToastify
        .prompt({
          body: "¿Desea eliminar este extra costo?",
          answers: {
            Sí: true,
            No: false,
          },
          type: "success",
        })
        .then(async (value) => {
          if (value) {
            this.$vToastify.loader("Eliminando registro...");

            const payload = { ids: Array.isArray(id) ? id : [id] };

            const response = await eliminarExtraCostos(payload);

            if (response.message === "OK") {
              await this.getData();

              this.$vToastify.stopLoader();

              this.$vToastify.success(response.data, "Éxito");
            } else {
              this.$vToastify.error(response.data, "Error");

              this.$vToastify.stopLoader();
            }
          }
        });
    },

    async deleteMultiple() {
      if (this.dataChecked.length === 0)
        return this.$vToastify.warning(
          "Debe seleccionar registros para eliminar.",
          "¡Precaución!"
        );

      this.$vToastify
        .prompt({
          body: `¿Desea eliminar ${this.dataChecked.length} registros?`,
          answers: {
            Sí: true,
            No: false,
          },
          type: "success",
        })
        .then(async (value) => {
          if (value) {
            this.$vToastify.loader("Eliminando Registros...");

            const payload = { ids: this.dataChecked };

            const response = await eliminarExtraCostos(payload);

            if (response.message === "OK") {
              await this.getData();

              this.$vToastify.stopLoader();

              this.$vToastify.success(response.data, "Éxito");
            } else {
              this.$vToastify.error(response.data, "Error");

              this.$vToastify.stopLoader();
            }

            this.dataChecked = [];
          }
        });
    },
  },

  watch: {
    extraCostISModalVisibility: async function (newVal) {
      if (newVal) {
        this.openModal("modal");

        this.headers = [
          "T. Asignación",
          "F. Servicio",
          "N° contenedor",
          "Bill lading",
          "T. Cargo",
          "Proveedor",
          "Código",
          "Moneda",
          "Costo",
          "Venta",
          // 'Forma de pago',
          "Unidad",
          "¿Manifestado BL?",
          "IVA",
          "Naviera",
          "Puerto",
          "Comentarios",
          "Acciones",
        ];

        await this.getData();
      } else {
        this.closeModal("modal");
      }
    },

    extraCostsISData: function (_new) {
      if (_new) {
        this.dataAux = _new;

        this.generarBotonesAcciones();
      }
    },
  },
};
</script>
